/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cuddly_Long_Bison_TickleInputs */

const fr_cuddly_long_bison_tickle = /** @type {(inputs: Cuddly_Long_Bison_TickleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cours assistés`)
};

/**

* @param {Cuddly_Long_Bison_TickleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const cuddly_long_bison_tickle = /** @type {((inputs?: Cuddly_Long_Bison_TickleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cuddly_Long_Bison_TickleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_cuddly_long_bison_tickle(inputs)
});